// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__3KJQN","log":"ModalInventoryLogs_log__1Edka","date":"ModalInventoryLogs_date__1CRq9","userName":"ModalInventoryLogs_userName__1syxJ"};